export function attachPropertiesToComponent(component, properties) {
    var ret = component;
    for (var key in properties) {
        if (Object.prototype.hasOwnProperty.call(properties, key)) {
            ret[key] = properties[key];
        }
    }
    return ret;
}
